import { HttpClient } from '@angular/common/http';
import { config } from '../app.config';
import { of } from 'rxjs';
import get from 'lodash.get';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var NavigationService = /** @class */ (function () {
    function NavigationService(http) {
        this.http = http;
        this.initialPageData = JSON.parse(get(document.getElementById('initialPageData'), 'innerHTML') || null);
    }
    NavigationService.prototype.getTopNavigation = function () {
        if (this.initialPageData && this.initialPageData.topNavigation) {
            return of(this.initialPageData.topNavigation);
        }
        return this.http.get(config.api + "/bgnavigation/getTopNavigation");
    };
    NavigationService.prototype.getLanguage = function () {
        return this.http.get("ubaseline/api/siteSettings/get/endpoint");
    };
    NavigationService.prototype.getHeaderNavigation = function () {
        if (this.initialPageData && this.initialPageData.headerNavigation) {
            return of(this.initialPageData.headerNavigation);
        }
        return this.http.get("/ubaseline/api/bgnavigation/getHeaderNavigation");
    };
    NavigationService.prototype.getFooterNavigation = function () {
        if (this.initialPageData && this.initialPageData.footerNavigation) {
            return of(this.initialPageData.footerNavigation);
        }
        return this.http.get("/ubaseline/api/bgnavigation/getFooterNavigation");
    };
    NavigationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NavigationService_Factory() { return new NavigationService(i0.ɵɵinject(i1.HttpClient)); }, token: NavigationService, providedIn: "root" });
    return NavigationService;
}());
export { NavigationService };
